export enum FontCategory {
    display = 'Display',
    handwriting = 'Hand Writing',
    monospace = 'Mono Space',
    'sans-serif' = 'Sans Serif',
    'serif' = 'Serif',
}
